
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Tarayıcı menünüzü açın`,
's182ab2d6c997515f': `Daha iyi bir deneyim ve kolay erişim için Ana Ekranınıza ekleyin.`,
's1b9047d53d9f9d22': `2) Gezinme çubuğunda Paylaş'a basın`,
's2d90afa5dcca2c0e': `3) "Ana Ekrana Ekle" seçeneğine kadar aşağı kaydırın`,
's37a9e8aec5713460': `Daha Fazla`,
's4593f304dac8848c': `2) "Ana Ekrana Ekle"ye dokunun`,
's54cfbb14f46396d4': `1) Ana tarayıcınızda açın`,
's6196153c4b0c1ea0': `Yükle`,
's922329d6f6213590': `Dock’a Ekle`,
'sa5ef80b4bb9b39f8': `Küçült`,
'sa7551383d1897fcc': `2) Dock’a ekleye basın`,
'sba52286c21552a4e': `Daha iyi bir deneyim ve kolay erişim için cihazınıza yükleyin.`,
'sc79fd7641eb9a975': `Talimatları gizle`,
'scdaf4bbff76674c8': `Ana Ekrana Ekle`,
'se740f75b95a51807': `Daha iyi bir deneyim ve kolay erişim için Dock’a ekleyin.`,
'sfea652f6580ff086': `Bu site uygulama işlevselliğine sahiptir.`,
    };
  